var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "url(#paint0_linear_1162_1113)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "url(#paint1_linear_1162_1113)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 9.44772 11.4477 9 12 9H14C14.5523 9 15 9.44772 15 10V22C15 22.5523 14.5523 23 14 23H12C11.4477 23 11 22.5523 11 22V10Z",
    fill: "#E96092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 9.44772 11.4477 9 12 9H14C14.5523 9 15 9.44772 15 10V22C15 22.5523 14.5523 23 14 23H12C11.4477 23 11 22.5523 11 22V10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 9.44772 11.4477 9 12 9H14C14.5523 9 15 9.44772 15 10V22C15 22.5523 14.5523 23 14 23H12C11.4477 23 11 22.5523 11 22V10Z",
    stroke: "#E96092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 10C16.9941 9.44772 17.4419 9 17.9941 9H19.9941C20.5464 9 20.9941 9.44772 20.9941 10V22C20.9941 22.5523 20.5464 23 19.9941 23H17.9941C17.4419 23 16.9941 22.5523 16.9941 22V10Z",
    fill: "#E96092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 10C16.9941 9.44772 17.4419 9 17.9941 9H19.9941C20.5464 9 20.9941 9.44772 20.9941 10V22C20.9941 22.5523 20.5464 23 19.9941 23H17.9941C17.4419 23 16.9941 22.5523 16.9941 22V10Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9941 10C16.9941 9.44772 17.4419 9 17.9941 9H19.9941C20.5464 9 20.9941 9.44772 20.9941 10V22C20.9941 22.5523 20.5464 23 19.9941 23H17.9941C17.4419 23 16.9941 22.5523 16.9941 22V10Z",
    stroke: "#E96092"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1162_1113",
    x1: 6.70625,
    y1: 5.6,
    x2: 23.5063,
    y2: 29.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490288,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1162_1113",
    x1: 7,
    y1: 1.5,
    x2: 25,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E96092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511336,
    stopColor: "#A42855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96092"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.b62b347bb8ea78fe1f5f890a5839e1ee.svg";
export { ForwardRef as ReactComponent };